import React from 'react';

import SubHeader from '../../components/subheader';
import Tab from '../../components/tab';
import GeneralSettingsPage from './general-settings-page';
import CustomizationEmail1Tab from './customization-email-1-tab';
import CustomizationEmail2Tab from './customization-email-2-tab';
import CustomizationEmail3Tab from './customization-email-3-tab';

export class DashboardEmailsSettingsPage extends React.Component {
	// TODO: in the future we should put this in the Tab Component instead
	// if we want all tabs to have this behavior
	onTabChange = (e, {activeIndex}) => {
		switch (activeIndex) {
			case 0:
				this.props.history.push('/dashboard/emails/settings/general');
				break;
			case 1:
				this.props.history.push('/dashboard/emails/settings/customization/1');
				break;
			case 2:
				this.props.history.push('/dashboard/emails/settings/customization/2');
				break;
			case 3:
				this.props.history.push('/dashboard/emails/settings/customization/3');
				break;
			default:
				this.props.history.push('/dashboard/emails/settings/general');
				break;
		}
	}

	getActiveIndex(pathname) {
		switch (pathname) {
			case '/dashboard/emails/settings/general':
				return 0;
			case '/dashboard/emails/settings/customization/1':
				return 1;
			case '/dashboard/emails/settings/customization/2':
				return 2;
			case '/dashboard/emails/settings/customization/3':
				return 3;
			default:
				return 0;
		}
	}

	render () {
		const panes = [
			{menuItem: 'General', Content: GeneralSettingsPage, props: this.props},
			{menuItem: '1st Email', Content: CustomizationEmail1Tab, props: this.props},
			{menuItem: '2nd Email', Content: CustomizationEmail2Tab, props: this.props},
			{menuItem: '3rd Email', Content: CustomizationEmail3Tab, props: this.props}
		];
		const activeIndex = this.getActiveIndex(this.props.location.pathname);

		return (
			<div>
				<SubHeader>
					<Tab panes={panes} activeIndex={activeIndex} onTabChange={this.onTabChange}/>
				</SubHeader>
			</div>
		);
	}
}

export default DashboardEmailsSettingsPage;



// WEBPACK FOOTER //
// ./src/containers/dashboard-emails-settings-page/index.js